import { InputAdornment, TextField } from '@mui/material';
import React, { useEffect } from 'react';
import { useFormContext, useWatch, Controller } from 'react-hook-form';
import { validDecimalAndLength } from '../../ModificationsUtils';
import { insuranceAmount } from 'app/models/Placement/PlacementMods';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';

export const InsuranceAmount = ({ isModEdit }: { isModEdit: boolean }) => {
  const { control, setValue } = useFormContext();
  const { t } = useTranslation();
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });
  const insuranceAmountVal = useWatch({ name: 'insuranceAmount' });

  useEffect(() => {
    if (insuranceAmountVal) setValue('insuranceAmount', insuranceAmountVal);
  }, []);

  return (
    <Controller
      name={insuranceAmount}
      control={control}
      render={({ field: { onChange, value, ...rest } }) => (
        <TextField
          value={insuranceAmountVal}
          variant="filled"
          fullWidth
          label={`${t(`placement.placementMods.${insuranceAmount}`)}`}
          onChange={e => {
            if (validDecimalAndLength(e.target.value, { numberLength: 6, decimalLength: 2 })) {
              setValue('insuranceAmount', e.target.value);
              onChange(e.target.value);
            }
          }}
          InputLabelProps={{
            shrink: value ?? null,
          }}
          InputProps={{
            readOnly: !isModEdit,
            style: {
              pointerEvents: !isModEdit ? 'none' : 'auto',
            },
            startAdornment: <>{value && <InputAdornment position="start">{t('currency.dollar')}</InputAdornment>}</>,
            sx: { fontSize: '14px' },
          }}
          disabled={isSaveModApiCalling}
          {...rest}
        />
      )}
    />
  );
};
